import logo from "../../images/aivy_logo3.png";
import { useNavigate } from "react-router-dom";

const Footer = () => {
  const navigate = useNavigate();
  const handleNavigation = (path: string): void => {
    navigate(path);
  };
  
  return (
    <footer className="bg-gray-50 border-t border-[#E5E5E5] py-12 px-4 md:px-8 w-full">
      <div className="max-w-7xl mx-auto">
        <div className="flex flex-col lg:flex-row gap-12 lg:gap-16">
          {/* 로고 및 소개 영역 */}
          <div className="flex flex-col gap-2 max-w-md">
            <div className="flex items-center gap-2">
              <img src={logo} alt="Aivy Logo" className="w-8 h-8" />
              <h2 className="text-xl font-serif-en font-semibold text-gray-900">
                Aivy
              </h2>
            </div>
            <p className="text-sm leading-relaxed text-gray-700 font-serif-kr">
              Aivy는 "AI + Ivy"의 조합으로, 'Always In Various Years of you'라는 의미를 담았습니다.
              당신의 모든 시간, 모든 순간에 함께하는 AI 동반자로서, 생애 첫 발걸음부터 인생의 모든 여정까지 가장 믿음직한 케어 파트너가 되어드립니다.
            </p>
            <p className="text-sm text-gray-600 font-serif-kr">
              © 2025 Aivy AI
            </p>
          </div>

          {/* 링크 영역 */}
          <div className="flex flex-col sm:flex-row gap-8 sm:gap-12 lg:gap-16">
            {/* 회사 정보 */}
            <div className="flex flex-col gap-4 min-w-[160px]">
              <h3 className="text-gray-900 text-base font-semibold">
                회사
              </h3>
              <div className="flex flex-col gap-2">
                <p className="text-sm text-gray-900 font-semibold">
                  (주)디에이블
                  </p>
                  <a href="tel:070-8805-3009" className="text-sm text-gray-900 font-semibold">
                  070-8805-3009
                </a>
              </div>
            </div>

            {/* 문의 */}
            <div className="flex flex-col gap-4 min-w-[160px]">
              <h3 className="text-gray-900 text-base font-semibold">
                문의
              </h3>
              <div className="flex flex-col gap-2">
                <button
                  type="button"
                  className="text-left text-sm text-gray-900 font-semibold hover:text-gray-900 transition-colors"
                  onClick={() => handleNavigation("/cs/odo/create")}
                >
                  문의하기
                </button>
              </div>
            </div>

            {/* 정책 */}
            <div className="flex flex-col gap-4 min-w-[160px]">
              <h3 className="text-gray-900 text-base font-semibold">
                정책
              </h3>
              <div className="flex flex-col gap-2">
                <button
                  type="button"
                  className="text-left text-sm text-gray-900 font-semibold hover:text-gray-900 transition-colors"
                  onClick={() => handleNavigation("/policy/privacy")}
                >
                  개인정보 처리방침
                </button>
                <button
                  type="button"
                  className="text-left text-sm text-gray-900 font-semibold hover:text-gray-900 transition-colors"
                  onClick={() => handleNavigation("/policy/terms")}
                >
                  서비스 이용약관
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
